<template>

    <el-form ref="form" :model="form" :rules="rules" label-width="9em" class="baseInfoForm hsRequired">

        <div class="formGroup">
            <div class="groupItem">
                <!--头像-->
                <div v-if="form.avatar && files.length==0 && !tempUrl" class="upImg widthImg" style="width:100px; height: 130px">
                    <img :src="location(form.avatar)"  width="100" height="130" />
                    <!--&lt;!&ndash; <div v-else class="noImg"><i class="el-icon-user-solid"></i></div> &ndash;&gt;-->
                    <!--<el-button v-if="form.avatar" @click="deleteAvatar" icon="el-icon-delete"></el-button>-->
                </div>
                <div class="uploaderDiv">
                    <img :src="tempUrl" v-if="tempUrl" width="100" height="130" />
                    <el-button size="mini" @click="goFile" style="margin-top: 5px">上传照片</el-button>
                    <input type="file" ref="file" @change="changeUpload" hidden accept="image/jpeg" />

                    <!-- vueCropper 剪裁图片实现-->
                    <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
                        <div class="cropper-content">
                            <div class="cropper" style="text-align:center">
                                <vueCropper
                                        ref="cropper"
                                        :img="option.img"
                                        :outputSize="option.size"
                                        :outputType="option.outputType"
                                        :info="true"
                                        :full="option.full"
                                        :canMove="option.canMove"
                                        :canMoveBox="option.canMoveBox"
                                        :original="option.original"
                                        :autoCrop="option.autoCrop"
                                        :fixed="option.fixed"
                                        :fixedNumber="option.fixedNumber"
                                        :centerBox="option.centerBox"
                                        :infoTrue="option.infoTrue"
                                        :fixedBox="option.fixedBox"
                                ></vueCropper>
                            </div>
                        </div>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <div class="formItem">

                <el-form-item label="姓名" prop="username">
                    <el-input v-model="form.username" placeholder="请填写姓名" maxlength="20">
                    </el-input>
                </el-form-item>

                <el-form-item label="性别" prop="gender">
                    <el-radio-group v-model="form.gender" size="medium">
                        <el-radio border v-for="item in genderOptions" :key="item.id" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="出生日期" prop="birthday">
                    <el-date-picker
                        v-model="form.birthday"
                        type="date"
                        :picker-options="pickerOptions"
                        placeholder="请选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="现居住地" prop="address">
                    <el-cascader
                        v-model="form.address"
                        filterable
                        :options="addressOptions"
                        :props="addressOptionsProps">
                    </el-cascader>
                </el-form-item>

                <el-form-item label="工作经验" prop="exp">
                    <el-select v-model="form.exp" placeholder="请选择工作经验" clearable>
                        <el-option v-for="item in expOptions" :key="item.id" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="政治面貌" prop="politicalStatus">
                    <el-select v-model="form.politicalStatus" placeholder="请选择政治面貌" clearable>
                        <el-option v-for="item in politicalStatusOptions" :key="item.id" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="个人优势" prop="selfEvaluation">
                    <el-input
                        type="textarea"
                        v-model="form.selfEvaluation"
                        placeholder="简短描述个人优势和特长，向企业展示工作上的特别能力"
                        :autosize="{ minRows: 2, maxRows: 4}"
                        maxlength="150"
                        show-word-limit>
                    </el-input>
                </el-form-item>

            </div>
        </div>

        <!--简历联系方式表单-->
        <div class="formGroup">
            <div class="groupItem">
                <h3>联系方式</h3>
            </div>
            <div class="formItem">
                <el-form-item label="手机号码" prop="mobilePhone">
                    <el-input
                        v-model="form.mobilePhone"
                        placeholder="请输入11位手机号码"
                        maxlength="11">
                    </el-input>
                </el-form-item>

                <el-form-item label="电子邮箱" prop="email">
                    <el-input
                        v-model="form.email"
                        placeholder="请输入电子邮箱"
                        maxlength="30">
                    </el-input>
                </el-form-item>
            </div>
        </div>

        <!--简历求职意向表单-->
        <div class="formGroup">
            <div class="groupItem">
                <h3>求职意向</h3>
            </div>
            <div class="formItem">

                <el-form-item label="工作性质" prop="willNature">
                    <el-radio-group v-model="form.willNature" size="medium">
                        <el-radio border v-for="item in willNatureOptions" :key="item.id" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="工作地区" prop="city">
                    <el-cascader
                        v-model="form.city"
                        filterable
                        :options="addressOptions"
                        :props="addressOptionsProps">
                    </el-cascader>
                </el-form-item>

                <el-form-item label="期望职能" prop="expectPosition">
                    <el-select v-model="form.expectPosition" placeholder="请选择职能" clearable filterable multiple :multipleLimit="3">
                        <el-option v-for="item in expectPositionOptions" :key="item.id" :label="item.label" :value="item.value" ></el-option>
                    </el-select>
                    <!--<el-cascader-->
                            <!--v-model="form.expectPosition"-->
                            <!--filterable-->
                            <!--:props="{ multiple: true ,checkStrictly: true}"-->
                            <!--clearable-->
                            <!--placeholder="请选择职能"-->
                            <!--:options="expectPositionOptions">-->
                    <!--</el-cascader>-->
                </el-form-item>

                <el-form-item label="期望行业" prop="expectIndustry">
                    <el-select v-model="form.expectIndustry" placeholder="请选择行业" clearable filterable multiple :multipleLimit="3">
                        <el-option v-for="item in expectIndustryOptions" :key="item.id" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="willSalaryStart" label="薪资要求">

                    <el-col :span="11">
                        <el-form-item prop="willSalaryStart">
                            <el-select v-model="form.willSalaryStart" placeholder="请选择" clearable @change="changeWillSalaryStart">
                                <el-option v-for="item in willSalaryStartOptions" :key="item.id" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col class="line" :span="2"> — </el-col>

                    <el-col :span="11">
                        <el-form-item prop="willSalaryEnd">
                            <el-select v-model="form.willSalaryEnd" placeholder="请选择" clearable :disabled="!form.willSalaryStart" @change="changeWillSalaryEnd">
                                <el-option v-for="item in willSalaryEndOptions" :key="item.id" :label="item.name" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-form-item>

                <el-form-item label="到岗时间" prop="arrivalTime">
                    <el-select v-model="form.arrivalTime" placeholder="请选择" clearable>
                        <el-option v-for="item in arrivalTimeOptions" :key="item.id" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="updateResumeBaseInfo()" v-if="editStatus.status==true">更新保存</el-button>
                    <el-button type="primary" @click="saveResumeBaseInfo()" v-else>保存</el-button>
                    <el-popconfirm
                        title="确认取消编辑？"
                        @confirm="cancel()"
                        placement="top-start"
                        icon="el-icon-info"
                        icon-color="red"
                        class="ml10">
                        <el-button slot="reference">取消</el-button>
                    </el-popconfirm>
                </el-form-item>

            </div>
        </div>

    </el-form>
</template>
<script>
    import {chunkFile,mergeFile} from '@/api/file';
    import {saveResumeBaseInfo,updateResumeBaseInfo} from '@/api/resume';
    import address from '@/utils/address';
    import {getTreeListByDictType} from '@/api/dict';
    import axios from 'axios';

    export default {
        name: 'baseInfoForm',
        props: ['form','editStatus','newResumeFlag'],
        data () {
            return{
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6
                    }
                },
                // 表单提交校验规则
                rules: {
                    username:[
                        {required: true, message: '请输入姓名'},
                        {min: 1, max: 20, message: '仅支持输入20个字符'},
                        {pattern: /^[\u4E00-\u9FA5]{0,20}$/, message: '仅支持中文'}
                    ],
                    gender:[
                        {required: true, message: '请选择性别'},
                    ],
                    birthday:[
                        {required: true, message: '请选择生日'},
                    ],
                    address:[
                        {required: true, message: '请选择现居住地'},
                    ],
                    exp:[
                        {required: true, message: '请选择工作经验'},
                    ],
                    politicalStatus:[
                        {required: true, message: '请选择政治面貌'},
                    ],
                    selfEvaluation:[
                        {required: true, message: '请填写个人优势'},
                    ],
                    mobilePhone: [
                        {required: true, message: '请输入手机号码'},
                        {pattern:/^1[0-9]{10}$/, message: '请输入11位手机号码'}
                    ],
                    email: [
                        {required: true, message: '请输入电子邮箱'},
                        {min: 1, max: 30, message: '请输入有效的电子邮箱'},
                        {pattern:/^([a-z0-9A-Z]+[-|\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/, message: '请输入有效的电子邮箱'}
                    ],
                    willNature: [
                        {required: true, message: '请选择工作性质'},
                    ],
                    city: [
                        {required: true, message: '请选择工作地区'},
                    ],
                    expectPosition: [
                        {required: true, message: '请选择期望职能'},
                    ],
                    willSalaryStart: [
                        {required: true, message: '请选择薪资要求'},
                    ],
                    willSalaryEnd: [
                        {required: true, message: '请选择薪资要求'},
                    ],
                },
                willSalaryEndOptions: [],
                // 附件文件上传对象
                files: [],
                addressOptionsProps: {
                    value: 'city',
                    label: 'city',
                    children: 'children'
                },
                expectPositionOptions: [],  // 职能选项
                expOptions: [], // 工作经验
                politicalStatusOptions: [], // 政治面貌
                genderOptions: [],  // 性别
                willNatureOptions: [],  // 工作性质
                expectIndustryOptions: [],  // 期望行业
                willSalaryStartOptions: [], // 薪资
                arrivalTimeOptions: [], // 到岗时间
                dialogVisible: false,
                // 裁剪组件的基础配置option
                option: {
                    img: '', // 裁剪图片的地址
                    info: true, // 裁剪框的大小信息
                    outputSize: 0.8, // 裁剪生成图片的质量
                    outputType: 'jpeg', // 裁剪生成图片的格式
                    canScale: false, // 图片是否允许滚轮缩放
                    autoCrop: true, // 是否默认生成截图框
                    // autoCropWidth: 300, // 默认生成截图框宽度
                    // autoCropHeight: 200, // 默认生成截图框高度
                    fixedBox: true, // 固定截图框大小 不允许改变
                    fixed: true, // 是否开启截图框宽高固定比例
                    fixedNumber: [10, 13], // 截图框的宽高比例
                    full: true, // 是否输出原图比例的截图
                    canMoveBox: false, // 截图框能否拖动
                    original: false, // 上传图片按照原始比例渲染
                    centerBox: true, // 截图框是否被限制在图片里面
                    infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                },
                // 防止重复提交
                loading: false,
                tempUrl: "",
            };
        },
        created() {
            this.loadDictData();
            if (this.form.willSalaryEnd) {
                let willSalaryEndBak = this.form.willSalaryEnd;
                this.changeWillSalaryStart();
                this.form.willSalaryEnd = willSalaryEndBak;
            }
        },
        computed: {
            location(){
                return function (avatar){
                    let imagePath = encodeURI(avatar);
                    return `/files?imagePath=${imagePath}`;
                }
            },
            // 现居住地选项参数
            addressOptions(){
                return address.addressOptions;
            },
            avatarFileSize(){
                return this.files.length;
            }
        },
        methods: {
            goFile() {
                this.$refs.file.click();
            },
            // 上传按钮   限制图片大小
            changeUpload(file, fileList) {
                if (this.$refs.file.files[0].type != "image/jpeg") {
                    this.$message.error("仅支持jpg图片");
                    return ;
                }
                if (this.$refs.file.files[0].size > 10485760) {
                    this.$message.error("图片大小不能超过10MB");
                    return ;
                }
                // 上传成功后将图片地址赋值给裁剪框显示图片
                this.$nextTick(() => {
                    this.option.img = window.URL.createObjectURL(this.$refs.file.files[0]);
                    this.dialogVisible = true
                })
            },
            // 点击裁剪，这一步是可以拿到处理后的地址
            finish() {
                this.$refs.cropper.getCropData((data) => {
                    this.dialogVisible = false;
                    let file = this.dataURLtoFile(data, "123");
                    this.tempUrl = data;
                    let time = new Date().getTime();
                    let formData = new FormData();
                    formData.append("chunkNumber", 1);
                    formData.append("identifier", time);
                    formData.append("filename", time + ".jpg");
                    formData.append("totalChunks", 1);
                    formData.append("file", file);
                    axios.post('api/file/chunk', formData).then(res => {
                        mergeFile({
                            name: time + ".jpg",
                            uniqueIdentifier: time
                        }).then((res) => {
                            this.form.avatarFileId = res.data.fileId;
                            this.$refs.file.value = '';
                       })
                    });
                })
            },
            // base64转blob
            base64ToBlob(base64Data) {
                let arr = base64Data.split(','),
                    fileType = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    l = bstr.length,
                    u8Arr = new Uint8Array(l);
                while (l--) {
                    u8Arr[l] = bstr.charCodeAt(l);
                }
                return new Blob([u8Arr], {
                    type: fileType
                });
            },
            // blob转file
            blobToFile(newBlob, fileName) {
                newBlob.lastModifiedDate = new Date();
                newBlob.name = fileName;
                return newBlob;
            },
            // 将base64的图片转换为file文件
            convertBase64UrlToBlob(urlData) {
                let bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
                //处理异常,将ascii码小于0的转换为大于0
                let ab = new ArrayBuffer(bytes.length);
                let ia = new Uint8Array(ab);
                for (var i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }
                return new Blob([ab], { type: "image/jpeg" });
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            /** 获取字典数据 */
            loadDictData() {
                getTreeListByDictType("industry").then(response => {
                    this.expectIndustryOptions = response.data
                });
                getTreeListByDictType("work_nature").then(response => {
                    this.willNatureOptions = this.listParseIntByKey(response.data, "value");
                });
                getTreeListByDictType("sex").then(response => {
                    this.genderOptions = this.listParseIntByKey(response.data, "value");
                });
                getTreeListByDictType("political_outlook").then(response => {
                    this.politicalStatusOptions = response.data
                });
                getTreeListByDictType("work_experience").then(response => {
                    this.expOptions = response.data
                });
                getTreeListByDictType("function").then(response => {
                    this.expectPositionOptions = response.data
                });
                getTreeListByDictType("salary").then(response => {
                    this.willSalaryStartOptions = this.listParseIntByKey(response.data, "value");
                });
                getTreeListByDictType("arrival_time").then(response => {
                    this.arrivalTimeOptions = response.data
                });
            },
            changeWillSalaryEnd(){
                this.$forceUpdate();
            },
            changeWillSalaryStart() {
                this.form.willSalaryEnd = undefined;
                for(let i=0;i<5;i++){
                    let object = new Object();
                    object.value = this.form.willSalaryStart + (i+1)*1000;
                    object.name = object.value.toString().substring(0,object.value.toString().length - 3)+'K';
                    this.willSalaryEndOptions[i] = object;
                }
            },
            deleteAvatar(){
                if (this.form.avatar) {
                    this.form.avatar = '';
                }
            },
            // 保存简历基础信息
            saveResumeBaseInfo(){
                this.$refs["form"].validate(valid => {
                    if (!this.form.resumeName) {
                        this.$message.error("请填写简历名称");
                    }else if (valid){
                        let resumeBaseInfoForm = Object.assign({}, this.form);
                        resumeBaseInfoForm.city = JSON.stringify(resumeBaseInfoForm.city);
                        resumeBaseInfoForm.address = JSON.stringify(resumeBaseInfoForm.address);
                        resumeBaseInfoForm.expectIndustry = JSON.stringify(resumeBaseInfoForm.expectIndustry);
                        resumeBaseInfoForm.expectPosition = JSON.stringify(resumeBaseInfoForm.expectPosition);
                        saveResumeBaseInfo(resumeBaseInfoForm).then(res=>{
                            this.cancel();
//                            this.$store.commit('changeResumeRefreshFlag', true);
//                            this.$store.commit('changeNewResumeStatus', true);
                        }).catch(()=>{
                            this.$message.error("简历基础信息保存失败");
                        })
                    }
                })
            },
            updateResumeBaseInfo(){
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.form.city = JSON.stringify(this.form.city);
                        this.form.address = JSON.stringify(this.form.address);
                        this.form.expectIndustry = JSON.stringify(this.form.expectIndustry);
                        this.form.expectPosition = JSON.stringify(this.form.expectPosition);
                        updateResumeBaseInfo(this.form).then(res=>{
                            this.cancel();
//                            this.$store.commit('changeResumeRefreshFlag', true);
                        }).catch(()=>{
                            this.$message.error("简历基础信息保存失败");
                        })
                    }
                })
            },
            // 简历工作经历表单取消编辑状态
            cancel() {
                this.editStatus.id = 0;
                this.editStatus.status = false;
                this.$emit('editStatus', this.editStatus);
                this.$store.commit('changeResumeEditStatus', false);
                this.$store.commit('changeResumeBaseInfoEditStatus', false);
                if (this.newResumeFlag && this.newResumeFlag === true) {
                    this.$store.commit('changeUpdateNewResumeStatusFlag', true);
                }
                this.$store.commit('changeResumeRefreshFlag', true);
            }
        }
    };
</script>
<style lang="scss" scoped>
    .cropper-content {
        .cropper {
            width: auto;
            height: 300px;
        }
    }

    .uploaderDiv{
        text-align: center;
    }
</style>